module.exports = __webpack_public_path__ + "img/gmp2.4bc81f63.png";